import React from 'react';
import { Link } from 'react-router';
import styles from './FeaturedCategories.module.scss';
import { homeStoreCategoryStrip } from '../../../../data/categories';

const fallbackThumb = `${process.env.PUBLIC_URL}/images/store-desktop-thumbnail.png`;

const FeaturedCategories: React.FC = () => {
  return (
    <section className={styles.contentSection}>
      <div className={styles.strip}>
        {homeStoreCategoryStrip.map((category) => (
          <Link
            key={category.id}
            to={`/search?category=${encodeURIComponent(category.id)}`}
            className={styles.productCard}
          >
            {category.tag ? (
              <span
                className={`${styles.categoryTag} ${styles[`tag-${category.tag.type || 'default'}`]}`}
              >
                {category.tag.text}
              </span>
            ) : null}
            <div className={styles.productImage}>
              <div className={styles.categoryImageWrap}>
                <img
                  src={category.icon}
                  alt=""
                  className={styles.categoryThumb}
                  onError={(e) => {
                    const target = e.currentTarget as HTMLImageElement;
                    target.onerror = null;
                    target.src = fallbackThumb;
                  }}
                />
              </div>
            </div>
            <div className={styles.productInfo}>
              <div className={styles.productName}>{category.displayName || category.name}</div>
            </div>
          </Link>
        ))}
        <Link to="/categories" className={`${styles.productCard} ${styles.viewAllCard}`}>
          <div className={styles.productImage}>
            <div className={styles.viewAllContent}>
              <i className="fas fa-th-large" aria-hidden />
            </div>
          </div>
          <div className={styles.productInfo}>
            <div className={styles.productName}>View all</div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default FeaturedCategories;
